import { render, staticRenderFns } from "./GoodsOrderDetailDrawer.vue?vue&type=template&id=13ecfee9&scoped=true"
import script from "./GoodsOrderDetailDrawer.vue?vue&type=script&lang=js"
export * from "./GoodsOrderDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./GoodsOrderDetailDrawer.vue?vue&type=style&index=0&id=13ecfee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ecfee9",
  null
  
)

export default component.exports